import { render, staticRenderFns } from "./editgrouperiten.vue?vue&type=template&id=7547f03f&"
import script from "./editgrouperiten.vue?vue&type=script&lang=js&"
export * from "./editgrouperiten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports